import React from "react";
import { useWatch } from "react-hook-form";

import { AutoFormFieldProps } from "@autoform/react";

import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

export function AppliesToTicketingField({
  id,
  label,
  inputProps,
}: AutoFormFieldProps) {
  const value: boolean = useWatch({ name: id }) ?? false;
  const ticketing = useWatch({ name: "ticketing" });

  if (!ticketing) return null;

  const { key, onChange, ...rest } = inputProps;

  return (
    <div className="flex items-center space-x-2">
      <Checkbox
        id={id}
        checked={value}
        disabled={rest.disabled}
        onCheckedChange={(checked) => {
          onChange({
            target: { name: id, value: !!checked },
          } as unknown as React.ChangeEvent<HTMLInputElement>);
        }}
      />
      <Label htmlFor={id}>{label}</Label>
    </div>
  );
}
